module.exports = __webpack_public_path__ + "static/media/20ECE20.f2ec2930.jpg";